<template>
  <div>
    <v-card class="px-8 pt-3 pb-8">
      <v-layout wrap pt-4>
        <v-flex xs6>
          <h2>{{ $t('a') }}</h2>
        </v-flex>
        <v-flex xs6 text-end>
          <v-chip small color="primary" class="mt-1">
            {{ $t('onlyVisibleByAdmins') }}
          </v-chip>
        </v-flex>
      </v-layout>
      <v-layout wrap mt-2>
        <v-flex xs12>
          <small>
            <div class="mb-3">
                <div>{{ $t('b') }}</div>
                <div>{{ $t('c') }}</div>
                <div>{{ $t('d') }}</div>
            </div>
            <div>
              <v-layout wrap>
                <v-flex xs12 mb-1>
                  <div><b>{{ $t('d2') }}</b></div>
                </v-flex>
                <v-flex xs12 text-center v-if="user.company.labels.length === 0">
                  <i>{{ $t('e') }}</i>
                </v-flex>
                <v-flex xs12 text-center>
                  <v-chip label @click="showUpdateLabelDialog(label)" v-for="(label, key) in user.company.labels" :key="key" class="mx-3 my-1">
                    <span>{{ label.name }}</span>
                    <v-icon small class="ml-2">mdi-pen</v-icon>
                    <i v-if="label.isUsedByDefault" class="ml-2">{{ $t('f') }}</i>
                  </v-chip>
                </v-flex>
                <v-flex xs12 mt-4>
                  <v-btn outlined small @click="showCreateLabelDialog()">
                    <v-icon small class="mr-2">mdi-plus</v-icon>
                    {{ $t('g') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </small>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="isShowingCreateLabelDialog" width="35%" :persistent="isCreateLabelPending">
      <v-card class="pa-6">
        <div v-if="!isCreateLabelPending">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <h3 class="mb-7">{{ $t('h') }}</h3>
              <v-text-field v-model="labelToCreate.name" outlined label="Nom du nouveau label" dense hide-details autofocus/>
              <v-checkbox v-model="labelToCreate.isUsedByDefault" outlined dense hide-details>
                <template v-slot:label>
                  <small class="primary--text">{{ $t('i') }}</small>
                </template>
              </v-checkbox>
              <v-btn @click="createCompanyLabel" :disabled="!labelToCreate.name || isAnotherLabelAlreadyExistingWithThisLabelNameToCreate(labelToCreate.name)" class="mt-5 primary">{{ $t('j') }}</v-btn>
              <div v-if="isAnotherLabelAlreadyExistingWithThisLabelNameToCreate(labelToCreate.name)" class="orange--text mt-4">{{ $t('k') }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-progress-linear indeterminate color="primary" class="mt-1"></v-progress-linear>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingUpdateLabelDialog" width="35%" :persistent="isUpdateLabelPending">
      <v-card class="px-6 pb-6 pt-2">
        <div v-if="!isUpdateLabelPending">
          <v-layout wrap>
            <v-layout wrap>
              <v-flex xs12 text-right>
                <v-btn @click="showDeleteLabelDialog(labelToUpdate)" small text outlined class=" red--text">{{ $t('l') }}</v-btn>
              </v-flex>
            </v-layout>
            <v-flex xs12 text-center>
              <h3 class="mb-4 mt-4">{{ $t('m') }}</h3>
              <v-text-field v-model="labelToUpdate.name" outlined label="Nom du label" dense hide-details autofocus/>
              <v-checkbox v-model="labelToUpdate.isUsedByDefault" outlined dense hide-details>
                <template v-slot:label>
                  <small class="primary--text">{{ $t('n') }}</small>
                </template>
              </v-checkbox>
              <v-btn @click="updateCompanyLabel" :disabled="!labelToUpdate.name || isAnotherLabelAlreadyExistingWithThisLabelNameToUpdate(labelToUpdate.id, labelToUpdate.name)" small class="mt-5 primary mr-3">{{ $t('o') }}</v-btn>
              <v-btn @click="isShowingUpdateLabelDialog = false" class="mt-5 ml-3" small outlined>{{ $t('p') }}</v-btn>
              <div v-if="isAnotherLabelAlreadyExistingWithThisLabelNameToUpdate(labelToUpdate.id, labelToUpdate.name)" class="orange--text mt-4">{{ $t('q') }}</div>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-progress-linear indeterminate color="primary" class="mt-4"></v-progress-linear>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isShowingDeleteLabelDialog" width="35%" :persistent="isDeleteLabelPending">
      <v-card class="px-6 pb-6 pt-2">
        <div v-if="!isDeleteLabelPending">
          <v-layout wrap>
            <v-flex xs12 text-center>
              <h3 class="mb-4 mt-4">{{ $t('r') }}</h3>
              <div>{{ $t('s') }} <b>"{{ labelToDelete.name }}"</b> ?</div>
              <div>{{ $t('t') }}</div>
              <v-btn @click="deleteCompanyLabel" small class="mt-5 primary mr-3">{{ $t('u') }}</v-btn>
              <v-btn @click="isShowingDeleteLabelDialog = false" class="mt-5 ml-3" small outlined>{{ $t('v') }}</v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div v-else>
          <v-progress-linear indeterminate color="primary" class="mt-4"></v-progress-linear>
        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isShowingCreateLabelDialog: false,
    isCreateLabelPending: false,
    labelToCreate: {
      name: '',
      isUsedByDefault: false
    },

    isShowingUpdateLabelDialog: false,
    isUpdateLabelPending: false,
    labelToUpdate: {
      id: null,
      name: '',
      isUsedByDefault: false
    },

    isShowingDeleteLabelDialog: false,
    isDeleteLabelPending: false,
    labelToDelete: {
      id: null,
      name: ''
    }
  }),
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    showCreateLabelDialog() {
      this.isShowingCreateLabelDialog = true
    },
    async createCompanyLabel() {
      this.isCreateLabelPending = true
      await this.$functions.httpsCallable('createCompanyLabel')({
        name: this.labelToCreate.name,
        isUsedByDefault: this.labelToCreate.isUsedByDefault
      })
      this.isShowingCreateLabelDialog = false
      this.isCreateLabelPending = false
    },

    showUpdateLabelDialog(label) {
      this.labelToUpdate = JSON.parse(JSON.stringify(label))
      this.isShowingUpdateLabelDialog = true
    },
    async updateCompanyLabel() {
      this.isUpdateLabelPending = true
      await this.$functions.httpsCallable('updateCompanyLabel')({
        id: this.labelToUpdate.id,
        name: this.labelToUpdate.name,
        isUsedByDefault: this.labelToUpdate.isUsedByDefault
      })
      this.isShowingUpdateLabelDialog = false
      this.isUpdateLabelPending = false
    },

    showDeleteLabelDialog(label) {
      this.labelToDelete = JSON.parse(JSON.stringify(label))
      this.isShowingDeleteLabelDialog = true
    },
    async deleteCompanyLabel() {
      this.isDeleteLabelPending = true
      await this.$functions.httpsCallable('deleteCompanyLabel')({
        id: this.labelToDelete.id
      })
      this.isShowingUpdateLabelDialog = false
      this.isShowingDeleteLabelDialog = false
      this.isDeleteLabelPending = false
    },
    isAnotherLabelAlreadyExistingWithThisLabelNameToCreate(name) {
      return !!this.user.company.labels.find(label => label.name.trim() === name.trim())
    },
    isAnotherLabelAlreadyExistingWithThisLabelNameToUpdate(labelId, name) {
      return !!this.user.company.labels.find(label => label.name.trim() === name.trim() && label.id !== labelId)
    }
  },
  watch: {
    isShowingCreateLabelDialog: {
      handler(val) {
        if (!val) {
          this.labelToCreate = {
            name: '',
            isUsedByDefault: false
          }
        }
      }
    },
    isShowingUpdateLabelDialog: {
      handler(val) {
        if (!val) {
          this.labelToUpdate = {
            id: null,
            name: '',
            isUsedByDefault: false
          }
        }
      }
    },
    isShowingDeleteLabelDialog: {
      handler(val) {
        if (!val) {
          this.labelToDelete = {
            id: null,
            name: ''
          }
        }
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Labels pour vos dossiers",
    "b": "Créez des labels personnalisés afin d'organiser vos dossiers de compétences comme vous le souhaitez.",
    "c": "Les membres de votre équipe pourront alors tagger les dossiers de compétences avec ces labels.",
    "d": "Par exemple, créez un label \"Interne\" associé par défaut à tout nouveau dossier et un label \"Sous-traitant\".",
    "d2": "Labels de dossiers de compétences de votre entreprise :",
    "e": "Aucun label créé.",
    "f": "(associé automatiquement)",
    "g": "Créer un nouveau label",
    "h": "Créer un nouveau label",
    "i": "Associer automatiquement ce label à tout nouveau dossier",
    "j": "Créer",
    "k": "Un label avec ce nom existe déjà.",
    "l": "Supprimer ce label",
    "m": "Modifier le label",
    "n": "Associer automatiquement ce label à tout nouveau dossier",
    "o": "Mettre à jour",
    "p": "Annuler",
    "q": "Un label avec ce nom existe déjà.",
    "r": "Supprimer le label",
    "s": "Êtes-vous sûr de supprimer le label",
    "t": "Cela supprimera de manière irréversible ce label de tous les dossiers ayant été taggé avec celui-ci.",
    "u": "Supprimer",
    "v": "Annuler",
    "onlyVisibleByAdmins": "Uniquement visible par les admins"
  },
  "en": {
    "a": "Labels for your CVs",
    "b": "Create custom labels to organize your CVs as you wish.",
    "c": "Members of your team will be able to tag their CVs with these labels.",
    "d": "For example, create a label \"Consultant\" automatically tagging every new CV and a label \"Freelance\".",
    "d2": "Labels available to your team:",
    "e": "No label created.",
    "f": "(automatically tagging)",
    "g": "Create a new label",
    "h": "Create a new label",
    "i": "Automatically tag every new CV with this label",
    "j": "Create",
    "k": "A label with this name already exists.",
    "l": "Delete this label",
    "m": "Edit this label",
    "n": "Automatically tag every new CV with this label",
    "o": "Save",
    "p": "Cancel",
    "q": "A label with this name already exists.",
    "r": "Delete this label",
    "s": "Are you sure you want to delete the label",
    "t": "This will irreversibly remove this label from all the CVs that have been tagged with it.",
    "u": "Delete",
    "v": "Cancel",
    "onlyVisibleByAdmins": "Only visible by admins"
  }
}
</i18n>